var map = {
	"./menu-icon-discussion-act.png": 22218,
	"./menu-icon-discussion.png": 55373,
	"./menu-icon-invest-act.png": 13169,
	"./menu-icon-invest.png": 56666,
	"./menu-icon-me-act.png": 82804,
	"./menu-icon-me.png": 7331,
	"./menu-icon-study-act.png": 11941,
	"./menu-icon-study.png": 46766,
	"./menu-icon-wealth-act.png": 55197,
	"./menu-icon-wealth.png": 14966
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45922;